<template>
    <div class="panel-body">
        <div v-for="group in channel.items" :key="group.groupingName">
            <div class="row">
                <div class="col-md-12 clearfix">
                    <h3>{{group.groupingName}}</h3>
                </div>
            </div>
            <input-loader :fields="group.groupItems"></input-loader>
        </div>

        <div class="form-group row">
            <div class="col-md-9 ml-auto text-right">
                <button v-on:click="saveAdmin()" type="button" class="btn btn-primary">Save</button>
                <a :href="baseUrl+ '/channels'" class="btn btn-secondary">
                    Cancel
                </a>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host;
    import InputLoader from "../form/form-loader.vue";
    import getNestedProperty from "../../mixins/getNestedProperty.js";
    import maskSensitiveField from "../../mixins/maskSensitiveField.js";

    export default {
        name: "admin-specific",
        components: {
            "input-loader": InputLoader,
        },
        mixins: [
            getNestedProperty,
            maskSensitiveField
        ],
        props: ['channelvalues'],
        data() {
            return {
                channel: {
                    items: [],
                },
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
                baseUrl: base_url,
                canSeeAdminFields: dataObject.canSeeAdminFields,
                postURL: base_url + "/channels/" + dataObject.channel.id,
                loading: false
            };
        },
        methods: {
            saveAdmin: function () {
                this.loading = true;
                this.$emit("channel-specific-save", this.channel);
            },
            setItems: function () {
                var cvs = this.channelvalues;

                this.channel.items = [
                    {
                        groupingName : "Hooks",
                        groupItems : [
                            {
                                name : "product_pre_sync",
                                label : "Product Pre Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'pre_sync', 'product')) ? cvs.json_options.configuration.pre_sync.product[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "product_post_sync",
                                label : "Product Post Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'post_sync', 'product')) ? cvs.json_options.configuration.post_sync.product[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "create_variant_pre_sync",
                                label : "Create Variant Pre Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'pre_sync', 'create_variant')) ? cvs.json_options.configuration.pre_sync.create_variant[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "create_variant_post_sync",
                                label : "Create Variant Post Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'post_sync', 'create_variant')) ? cvs.json_options.configuration.post_sync.create_variant[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "delete_variant_pre_sync",
                                label : "Delete Variant Pre Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'pre_sync', 'delete_variant')) ? cvs.json_options.configuration.pre_sync.delete_variant[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "delete_variant_post_sync",
                                label : "Delete Variant Post Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'post_sync', 'delete_variant')) ? cvs.json_options.configuration.post_sync.delete_variant[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "single_attribute_pre_sync",
                                label : "Single Attribute Pre Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'pre_sync', 'single_attribute')) ? cvs.json_options.configuration.pre_sync.single_attribute[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "single_attribute_post_sync",
                                label : "Single Attribute Post Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'post_sync', 'single_attribute')) ? cvs.json_options.configuration.post_sync.single_attribute[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "attribute_pre_sync",
                                label : "Attributes Pre Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'pre_sync', 'attribute')) ? cvs.json_options.configuration.pre_sync.attribute[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "attribute_post_sync",
                                label : "Attributes Post Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'post_sync', 'attribute')) ? cvs.json_options.configuration.post_sync.attribute[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "inventory_pre_sync",
                                label : "Inventory Pre Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'pre_sync', 'inventory')) ? cvs.json_options.configuration.pre_sync.inventory[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "inventory_post_sync",
                                label : "Inventory Post Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'post_sync', 'inventory')) ? cvs.json_options.configuration.post_sync.inventory[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "price_pre_sync",
                                label : "Price Pre Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'pre_sync', 'price')) ? cvs.json_options.configuration.pre_sync.price[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "price_post_sync",
                                label : "Price Post Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'post_sync', 'price')) ? cvs.json_options.configuration.post_sync.price[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "details_pre_sync",
                                label : "Details Pre Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'pre_sync', 'details')) ? cvs.json_options.configuration.pre_sync.details[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "details_post_sync",
                                label : "Details Post Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'post_sync', 'details')) ? cvs.json_options.configuration.post_sync.details[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : 'asset_pre_sync',
                                label : 'Asset Pre Sync Class',
                                required : false,
                                type : 'text',
                                column : 'col-md-6 mb-4 d-flex flex-column justify-content-end',
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'pre_sync', 'asset')) ? cvs.json_options.configuration.pre_sync.asset[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : 'asset_post_sync',
                                label : 'Asset Post Sync Class',
                                required : false,
                                type : 'text',
                                column : 'col-md-6 mb-4 d-flex flex-column justify-content-end',
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'post_sync', 'asset')) ? cvs.json_options.configuration.post_sync.asset[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "related_pre_sync",
                                label : "Related Pre Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'pre_sync', 'related_products')) ? cvs.json_options.configuration.pre_sync.related_products[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "related_post_sync",
                                label : "Related Post Sync Class",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'post_sync', 'related_products')) ? cvs.json_options.configuration.post_sync.related_products[0] : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                        ],
                    },
                    {
                        groupingName : "Transformers",
                        groupItems : [
                            {
                                name : "inbound_product_data_transformer",
                                label : "Inbound Product DataTransformer",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'inbound_product_data_transformer')) ? cvs.json_options.configuration.inbound_product_data_transformer : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "inbound_details_data_transformer",
                                label : "Inbound Details DataTransformer",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'inbound_details_data_transformer')) ? cvs.json_options.configuration.inbound_details_data_transformer : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "inbound_inventory_data_transformer",
                                label : "Inbound Inventory DataTransformer",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'inbound_inventory_data_transformer')) ? cvs.json_options.configuration.inbound_inventory_data_transformer : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "inbound_assets_data_transformer",
                                label : "Inbound Assets DataTransformer",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'inbound_assets_data_transformer')) ? cvs.json_options.configuration.inbound_assets_data_transformer : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "inbound_attributes_data_transformer",
                                label : "Inbound Attributes DataTransformer",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'inbound_attributes_data_transformer')) ? cvs.json_options.configuration.inbound_attributes_data_transformer : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "inbound_prices_data_transformer",
                                label : "Inbound Prices DataTransformer",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'inbound_prices_data_transformer')) ? cvs.json_options.configuration.inbound_prices_data_transformer : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "inbound_variants_data_transformer",
                                label : "Inbound Variants DataTransformer",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'inbound_variants_data_transformer')) ? cvs.json_options.configuration.inbound_variants_data_transformer : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "inbound_child_details_data_transformer",
                                label : "Inbound Child Details DataTransformer",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'inbound_child_details_data_transformer')) ? cvs.json_options.configuration.inbound_child_details_data_transformer : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "inbound_product_json_data_transformer",
                                label : "Inbound Product Json DataTransformer",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'inbound_product_json_data_transformer')) ? cvs.json_options.configuration.inbound_product_json_data_transformer : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "inbound_category_data_transformer",
                                label : "Inbound Category DataTransformer",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'inbound_category_data_transformer')) ? cvs.json_options.configuration.inbound_category_data_transformer : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "inbound_product_pricelist_data_transformer",
                                label : "Inbound Price List DataTransformer",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'inbound_product_pricelist_data_transformer')) ? cvs.json_options.configuration.inbound_product_pricelist_data_transformer : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            }
                        ]
                    }
                ];
                if (cvs.type[cvs.channel_type] == 'Icecat') {
                    var icecat_item_group = {
                        groupingName : "Icecat Credentials",
                        groupItems : [
                            {
                                name : "icecat_username",
                                label : "Username",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'credentials', 'icecat_username')) ? cvs.json_options.credentials.icecat_username : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "icecat_token",
                                label : "API Token",
                                required : false,
                                type : "text",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'credentials', 'icecat_token')) ? cvs.json_options.credentials.icecat_token : "",
                                tooltip: '',
                                tooltip_position: 'top'
                            }
                        ],
                    }
                    this.channel.items.unshift(icecat_item_group);
                } // end if icecat
            }
        },
        mounted() {
            this.setItems();
        },
    };
</script>
